// extracted by mini-css-extract-plugin
export default {"agreementPageContainer":"agreementPage_agreementPageContainer__ZGVqM","agreementPageHeading":"agreementPage_agreementPageHeading__YkW8A"};